import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateStreamMutation } from "../graphql/mutations";
import type {
  CreateStreamMutationType,
  CreateStreamMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateStreamMutation = (
  options?: MutationHookOptions<
    CreateStreamMutationType,
    CreateStreamMutationVariablesType
  >
) => {
  return useMutation<
    CreateStreamMutationType,
    CreateStreamMutationVariablesType
  >(CreateStreamMutation, options);
};
